export default "__VITE_ASSET__6f21c7a1__"